// extracted by mini-css-extract-plugin
export default {"btnAction":"MembersSection_btnAction__Waz-I","title":"MembersSection_title__XM9PI"};